import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-incidenttype',
  templateUrl: './incidenttype.component.html',
  styleUrls: ['./incidenttype.component.css']
})
export class IncidenttypeComponent implements OnInit  {

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "Incidenttype";

  filterstatus: string = "ALL"; 
  dtOptions: DataTables.Settings = {};
    
  incidenttypeColl:any=[];


  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Incident Name', field: 'incidenttypename' },        
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex :1
  };

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal,private toastr: ToastrService) {
      this.fnServiceChanges();
  }
  
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    this.fngetIncidentType();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }

  //Event  
  fnActionEditClick(data) {

    if (!this.isedit) {
      return;
    }
  
      this.fnEditForm(data.incidenttypeid);
   }   
  
  fnActionDeleteClick(data) {
  
    if (!this.isdelete) {
      return;
    }
  
      this.fnDeleteConfirm(data.incidenttypeid,data.incidenttypename);
    }   
 
  fnActionExportClick()  {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: 'assetlist',
        //columnSeparator: document.querySelector("#columnSeparator").value
      };
     // this.gridApi.exportDataAsCsv(params);
  }
  fnActionFilterClick() {  

    this.filterbar.filterstatus = this.filterstatus;
    
    this.isfilter = !this.isfilter;
  }

  fnActionRefreshClick() { 
    this.fngetIncidentType()
  }

  fnApplyFilter(data) {
   // this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetIncidentType();
     
  }

  fnCurrentRouteChange() { 
    var queryParams = {};
    

    if (this.filterstatus != '') {     
      queryParams['status'] = this.filterstatus;
    }   

     this.router.navigate(
      [], 
      {
        relativeTo: this.route,
        queryParams: queryParams, 
      
      });
  }
  
  fnRemoveFilter(type) {
    
    if(type==='INACTIVE'){
      this.filterstatus="";
      this.fngetIncidentType();     
    }  
    else{
      this.filterstatus="";
      this.fngetIncidentType();    
    }
  }

  //Get
  fngetIncidentType() { 
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();   
      var data = {
          'incidenttypeid':0,
          'companyid': this.loginService.fnGetCompanyId(), 
          'filterstatus':this.filterstatus                                                                           
           
      }
      this.appService.getIncidentType(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   

                this.incidenttypeColl=res.json().result;
                this.fnSetTable();
                this.fnCurrentRouteChange();                     

            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{    
            this.fnHideProgress();                   
      
              this.toastr.error('Error', err);
      })
  }

  fnAddForm(){
    try{
      this.router.navigate(['/AddIncidentType']);
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }    
  }

  fnEditForm(deptid){
    try{
        let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
        }
        }
  
      this.router.navigate(['/AddIncidentType'], navigationExtras);
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(deptid,reftxt) {
    try{
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete incidenttype?',reftxt)
      .then((confirmed) => 
            {
              if(confirmed){
                this.fnDeleteForm(deptid,reftxt)
              }          
          }        
      );     
      //.catch(() => );
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid,reftxt){
       var data = {
         'incidenttypeid': deptid,            
       }
      this.appService.fnDeleteIncidentType(data)
        .subscribe(
          (res)=>{ 
         
           if(res.json().status===200){
              this.toastr.success('', " The incidenttype has been deleted successfully.");     
              this.fnInsertActivityLog('DELETE', deptid, reftxt);                                                                                                                                                                                                                                                                                                                                                                                           
              this.fngetIncidentType();
           }
           else {
            this.loginService.fnAPIError(res.json())
          }
            
          },
          (err)=>{          
            this.toastr.error('Error', err);
          })
  }
  fnSetTable() {
  
  }
  public fnSearchDatatable(value){    
  //  this.gridApi.setQuickFilter(value);
  }
  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }
  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.incidenttypeColl[index].hoverfocus="IN"
      }
      else{
        this.incidenttypeColl[index].hoverfocus=""
      }                
    }    
}
private fnExport() {

  const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
  modalRef.componentInstance.doctype = this.formname;
  modalRef.componentInstance.columnDefs = this.columnDefs;
  modalRef.componentInstance.contentColl = this.incidenttypeColl;
  modalRef.componentInstance.fnSetTable();
  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  
  });

}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }







}
